<template>
    <modal ref="popup">
        <template v-slot:modal-title>
            <h3 class="dmv-text dmv-text-large dmv-text-primary">{{title}}</h3>
        </template>

        <template v-slot:modal-body>
            <ul class="dmv-text">
                <li 
                    :key="text.header"
                    v-for="text in enumerableTexts">
                    <span class="dmv-text-medium-large dmv-text-primary" v-html="text.header"></span>
                    <br />
                    <span class="dmv-text-secondary" v-html="text.body"></span>
                </li>
            </ul>
        </template>

        <template v-slot:modal-footer>
            <div class="text-right">
                <button class="btn btn-outline-dark mr-3"
                        @click="hide">
                    {{resource('DmVisualizer_ConfirmationPopup_CancelButton_Text')}}
                </button>

                <slot></slot>
            </div>
        </template>
    </modal>
</template>

<script>
    import resourceMixin from '../../../Util/Mixins/resources';
    
    import Modal from '../../../Components/Util/Modal.vue';
    
    export default {
        name: "confirmation-popup",
        mixins: [resourceMixin],
        components: { Modal },
        methods: {
            show(){
                this.$refs.popup.show();
            },
            hide(){
                this.$refs.popup.hide();
            }
        },
        computed: {
            enumerableTexts(){
                //Ensure our texts can be enumerated
                return Array.isArray(this.texts) ? this.texts : [this.texts];
            }
        },
        props: {
            title: {
                type: String,
                required: true
            },
            texts: {
                type: Array | Object,
                required: true,
                default: () => ({
                    header: '',
                    body: ''
                })
            }
        }
    };
</script>

<style scoped src="../Style/confirmation-popup.scss" lang="scss">
</style>
